const STORAGE_KEY = 'belvoExternalId';
export const saveBelvoExternalId = (externalId) => {
    if (!externalId)
        return;
    try {
        localStorage.setItem(STORAGE_KEY, externalId);
    }
    catch {
    }
};
export const clearBelvoExternalId = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
    }
};
export const withBelvoExternalId = (search) => {
    let externalId = null;
    try {
        externalId = localStorage.getItem(STORAGE_KEY);
    }
    catch {
        return search;
    }
    if (!externalId || /[?&]external_id=/.test(search))
        return search;
    const separator = search.startsWith('?') ? '&' : '?';
    return `${search}${separator}external_id=${encodeURIComponent(externalId)}`;
};
